import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { BpService } from './bp.service';
import { EventGroupService } from './event-group.service'
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts"
// (pdfMake as any).vfs = pdfFonts.vfs;
import { SettingService } from './setting.service';
import { LedgerService } from './ledger.service';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { JvService } from './jv.service';
import { ChartOfAccountService } from './chart-of-account.service';
import { HierarchyService } from './hierarchy.service';
import { ToWords } from 'to-words';
import { ToastrService } from 'ngx-toastr';
// import { MainService as mainserviceEmb } from '../../emb/service/main.service';
import { ContraService } from './contra.service';
// import { BillService } from '../../operation/service/bill.service'
import { session } from 'src/environments/environment.session';
import { ReimbursementService } from './reimbursement.service';
import { HttpClient } from '@angular/common/http';
import { WorkService } from './work.service';
import {MainService as PortalMainService} from '../../portal/service/main.service'
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessDocumentPrintService {

  httpUrl;
  erpUser;
  b_acct_id


  constructor(private main: MainService, private bpService: BpService,private utf8EncodingService:Utf8EncodingService,
    private settingService: SettingService, private eventGroupService: EventGroupService,
    private ledgerService: LedgerService, private spinner: NgxSpinnerService,
    private jvService: JvService, private ch_acc_S: ChartOfAccountService,
    private hierarchyService: HierarchyService, private toastr: ToastrService,
    // private mainserviceEmb: mainserviceEmb,    private vbillservice: BillService,
    private portalMainService:PortalMainService,
    private contraService: ContraService,
  private reimbursementService: ReimbursementService,
    private http: HttpClient, private workService: WorkService
  ) {

    this.httpUrl = this.main.httpUrl;
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id;
  }

  AllPartyObj: any = {}
  partyDetailsObj: any = {}
  async getAllParties() {
    let resp = await this.settingService.getAllpartiesNew(this.b_acct_id);
    if (resp['error'] == false) {
      resp['data'].map((x: any) => {
        this.AllPartyObj[x['le_id']] = x['emp_name']
        this.partyDetailsObj[x['le_id']] = x

      });
    }
  }

  async getBankMappedCOA() {
    this.spinner.show()
    let resp = await this.contraService.getCashAtBankaccounts(this.b_acct_id);
    if (resp['error'] == false) {

      resp['data'].map((x: any) => {
        this.coa_mapped_bank[x['relation']] = x['bank_desc']
      })
      this.spinner.hide();
    } else {
      this.spinner.hide();
      // Swal.fire("Error", "...Error while getting  all fields list!", 'error');
    }
  }

  async getVendor() {
    let resp = await this.settingService.getAllVendors();
    if (resp['error'] == false) {
      // await resp['data'].map((x: any) => {
      //   this.AllPartyObj[x['le_id']] = x['org_name']
      //   this.partyDetailsObj[x['le_id']] = x
      // });

      for (let i = 0; i < resp['data'].length; i++) {
        this.AllPartyObj[resp['data'][i]['le_id']] = resp['data'][i]['org_name']
        this.partyDetailsObj[resp['data'][i]['le_id']] = resp['data'][i]
      }

    }
  }

  budHierObj: any = {}
  async getBudgetHier() {
    this.spinner.show()
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['table_name'] = 'bud_hier';
    var resp = await this.hierarchyService.getBudgetHierarchy(obj);
    if (resp['error'] == false) {
      resp.data.map((x: any) => {
        this.budHierObj[x['leaf_cd']] = x['leaf_value']
      })
      this.spinner.hide();
    } else {
      this.spinner.hide()
    }

  }
  chartOfAcc: any = []
  chartOfAccObj: any = {}
  async getChartOfAccount() {
    this.spinner.show()
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    let resp = await this.ch_acc_S.getchartofaccount(obj);
    if (resp['error'] == false) {
      this.spinner.hide()
      this.chartOfAcc = resp['data']
      this.chartOfAcc.map((x: any) => {
        this.chartOfAccObj[x['leaf_code']] = x['leaf_value']
      })
    } else {
      this.spinner.hide()
    }
  }
  workflowuser = []
  async getWorkflowloguser() {
    let obj: any = new Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['module_cd'] = this.salBill_apprdata['module_cd'] //'ACCOUNT'
    obj['status'] = 'ACTIVE'
    obj['node_cd'] = this.salBill_apprdata['node_cd']
    let resp = await this.portalMainService.getUsersForModuleWorkflow(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.spinner.hide();
      this.workflowuser = resp['data']

    } else {
      this.spinner.hide();
      this.toastr.error(resp['data'])
    }
  }

  salBill_apprdata: any = {}
  statusArr = []


  async viewStatus(element: any) {
    let obj: any = new Object();
    obj['doc_local_no'] = element.event_id;
    obj['b_acct_id'] = this.erpUser.b_acct_id;
    obj['doc_type'] = element.ar_actvty_tcd;
    obj['module_cd'] = element.module_cd//'ACCOUNT'
    obj['node_cd'] = element.ld_prj_cd;
    obj['is_account_module'] = element.is_account_module;
    let resp = await this.portalMainService.getWorkflowlog(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.salBill_apprdata = Object.assign({}, obj)
      this.salBill_apprdata['level'] = 1
      this.salBill_apprdata['branch'] = 1
      await this.getWorkflowloguser()

      resp['data'].map((x: any) => {
        if (x && 'remark' in x) {
          try {
            const parsedRemark = JSON.parse(x['remark']);
            if (typeof parsedRemark === 'object' && 'body' in parsedRemark) {
              x['remark'] = parsedRemark['body'];
            }
          } catch (e) {

          }
        }
        x['name'] = x['emp_name']
        if (x['user_id'] == -1) {
          x['name'] = "Contractor"
          x['role_cd'] = "Contractor"
        }
        x['name'] = x['user_name']
        if (x['name'] == undefined) {
          x['name'] = ''
        }
      })

      // for (let i = 0; i < resp.data.length; i++) {
      //   if (resp.data[i]['user_id'] == -1) {
      //     resp.data[i]['name'] = "Contractor"
      //     resp.data[i]['role_cd'] = "Contractor"
      //     continue;
      //   }
      //   for (let j = 0; j < this.workflowuser.length; j++) {
      //     if (resp.data[i]['user_id'] == this.workflowuser[j]['user_id'] && resp.data[i]['role_cd'] == this.workflowuser[j]['role_cd']) {
      //       resp.data[i]['name'] = this.workflowuser[j]['emp_name']
      //       resp.data[i]['role_cd'] = this.workflowuser[j]['role_cd']
      //     }
      //   }
      //   if (resp.data[i]['name'] == undefined) {
      //     resp.data[i]['name'] = ''

      //   }
      // }
      this.statusArr = resp.data
      return this.statusArr //This is used in task component for getting previous log info
      // $('#myModal1').modal('show');
    } else {
      return;
    }
  }

  async printCertificate(printObj: any, statusArr: any) {
    await this.getAllParties()
    await this.getVendor()
    let APPROVAL_HEADER = ""
    let DOWNLOAD_NAME = ""


    let tbl: any = {
      fontSize: 10,
      table: {
        headerRows: 0,
        widths: [370, 375],
        body: [],
      },
    };


    if (printObj.doc_type === "BP") {
      APPROVAL_HEADER = "BANK PAYMENT"
      DOWNLOAD_NAME = "bank-payment-cert"
      let obj: any = {}
      obj['b_acct_id'] = this.b_acct_id;
      obj['bp_id'] = [printObj['doc_local_no']];
      const BpResponse = await this.bpService.getList(JSON.stringify(obj))
      let dataToPrint: any;
      if (BpResponse['error'] === false) {
        dataToPrint = BpResponse['data'][0]
      } else {
        Swal.fire('ERROR', "Error While Printing Certificate", 'error');
      }


      let arr: any = [];
      arr.push({ text: "BP ID ", bold: true });
      arr.push(printObj["id"]);
      tbl.table.body.push(arr);

      arr = [];
      arr.push({ text: "Party Name  ", bold: true });
      arr.push(this.AllPartyObj[dataToPrint['party_id']]);
      tbl.table.body.push(arr);
      arr = [];
      arr.push({ text: "Amount", bold: true });
      arr.push(dataToPrint["bp_amount"]);
      tbl.table.body.push(arr);
      arr = [];
      arr.push({ text: "BP Date ", bold: true });
      arr.push({ text: new Date(dataToPrint['bp_date']).toLocaleDateString('en-GB').split('T')[0] });
      tbl.table.body.push(arr);




    } else if (printObj.doc_type === "SALARY_BILL") {
      APPROVAL_HEADER = "SALARY BILL"
      DOWNLOAD_NAME = "salary-bill-cert"

      let obj: any = {}
      obj['b_acct_id'] = this.b_acct_id;
      obj['id'] = printObj['doc_local_no'];
      obj['is_rec_or_pay'] = 'PAYABLE'
      let resp = await this.eventGroupService.geteventByID(JSON.stringify(obj));
      let dataToPrint: any;
      if (resp['error'] == false) {
        dataToPrint = resp['data'][0]
      } else {
        Swal.fire('ERROR', "Error While Printing Certificate", 'error');
      }



      let arr = [];
      arr.push({ text: "Deparment Bill ID", bold: true });
      arr.push(printObj["doc_local_no"]);
      tbl.table.body.push(arr);

      arr = [];
      arr.push({ text: "Bill ID", bold: true });
      arr.push({ text: dataToPrint['local_doc_no'] });
      tbl.table.body.push(arr);

      arr = [];
      arr.push({ text: "Bill Description", bold: true });
      arr.push({ text: dataToPrint['local_doc_desc'] });
      tbl.table.body.push(arr);
      arr = [];
      arr.push({ text: "Amount", bold: true });
      arr.push(dataToPrint["total_amt"]);
      tbl.table.body.push(arr);


    } else if (printObj.doc_type === "VENDOR_BILL_OPERATION") {
      APPROVAL_HEADER = "VENDOR BILL"
      DOWNLOAD_NAME = "vendor-bill-cert"
      let obj: any = {}
      obj['b_acct_id'] = this.b_acct_id;
      obj['id'] = printObj['doc_local_no'];
      obj['is_rec_or_pay'] = 'PAYABLE'
      let resp = await this.eventGroupService.geteventByID(JSON.stringify(obj));
      let dataToPrint: any;
      if (resp['error'] == false) {
        dataToPrint = resp['data'][0]
      } else {
        Swal.fire('ERROR', "Error While Printing Certificate", 'error');
      }
      let arr = [];
      arr.push({ text: "Deparment Bill ID", bold: true });
      arr.push(printObj["doc_local_no"]);
      tbl.table.body.push(arr);


      arr = [];
      arr.push({ text: "Bill ID", bold: true });
      arr.push({ text: dataToPrint['local_doc_no'] });
      tbl.table.body.push(arr);

      arr = [];
      let descArr = dataToPrint['local_doc_desc'].split("/");
      descArr.shift();
      arr.push({ text: "Bill Description", bold: true });
      arr.push({ text: descArr.join('/') });
      tbl.table.body.push(arr);


      arr = [];
      arr.push({ text: "Amount", bold: true });
      arr.push(dataToPrint["total_amt"]);
      tbl.table.body.push(arr);

    } else if (printObj.doc_type === "MANUAL_JOURNAL") {
      APPROVAL_HEADER = "MANUAL jOURNAL"
      DOWNLOAD_NAME = "manual-journal-cert"


      let obj: any = {}
      obj['b_acct_id'] = this.b_acct_id;
      obj['id'] = printObj['doc_local_no'];

      let resp = await this.ledgerService.getManulaJournalById(JSON.stringify(obj));
      let dataToPrint: any;
      if (resp['error'] === false) {
        dataToPrint = resp['data'][0]
      } else {
        Swal.fire('ERROR', "Error While Printing Certificate", 'error');
      }


      let arr = [];
      arr.push({ text: "Manual Journal ID", bold: true });
      arr.push(printObj["doc_local_no"]);
      tbl.table.body.push(arr);

      arr = [];
      arr.push({ text: "Journal ID", bold: true });
      arr.push(dataToPrint["jrnl_id"]);
      tbl.table.body.push(arr);



      arr = [];
      arr.push({ text: "Manula Journal Date ", bold: true });
      arr.push({ text: new Date(dataToPrint['acct_dt']).toLocaleDateString('en-GB').split('T')[0] });
      tbl.table.body.push(arr);

      arr = [];
      arr.push({ text: "Preparer Comment", bold: true });
      arr.push(dataToPrint["preparer_comment"]);
      tbl.table.body.push(arr);

    }


    const txt = "APPROVAL LOG FOR " + APPROVAL_HEADER;
    let dd: any = {
      pageSize: "A3",
      header: function (currentPage: any, pageCount: any) {
        let arr = [];
        let obj = {
          text: txt,
          alignment: "center",
          margin: [72, 40],
          fontSize: 15,
          bold: true,
        };
        arr.push(obj);
        return arr;
      },
      pageOrientation: "portrait",
      pageMargins: [40, 60, 40, 60],
      content: [],
    };

    dd.content.push(tbl);
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });


    let tbl1 = {
      fontSize: 15,
      table: {
        headerRows: 1,
        widths: [70, 124, 124, 124, 144, 125],
        body: [
          ["User ID", "User Name", "Designation", "Action", "Date", "Remark"],
        ],
      },
    };
    for (let i = 0; i < statusArr.length; i++) {
      let arr = [];
      arr.push(statusArr[i]["user_id"]);
      arr.push(statusArr[i]["user_name"]);
      arr.push(statusArr[i]["role_cd"]);
      arr.push(statusArr[i]["status"]);
      arr.push(statusArr[i]["create_timestamp"]);
      arr.push(statusArr[i]["remark"]);
      tbl1.table.body.push(arr);
    }
    dd.content.push(tbl1);
    // pdfMake.createPdf(dd).download(DOWNLOAD_NAME + ".pdf");
    pdfMake.createPdf(dd).open();
  }

  async printManualJournal(element: any) {
    if (Object.keys(element).length > 0) {
      await this._formatingDataForBpAndJv(element)
      await this.getworkflowlogforprint(element)
    }

    this.spinner.show()

    let txt = this.main.accInfo['account_name'] + '(' + this.main.accInfo['account_short_name'] + ')';
    let dd: any = {
      pageSize: 'A4',
      header: function (currentPage: any, pageCount: any) {
        let obj = { text: txt, alignment: 'center', blod: true, style: 'header', margin: [72, 40] };
        + "     Page No. - " + pageCount
        return obj;
      },
      footer: {
        columns: [
          { text: new Date().toLocaleString(), alignment: 'right', margin: [0, 0, 40, 0] }
        ]
      },
      // pageOrientation: 'portrait',
      pageOrientation: 'landscape',
      pageMargins: [40, 60, 40, 60],
      content: [
      ]
    };
    let header0 = {
      columns: [
        {
          width: '*',
          text: 'MANUAL VOUCHER',
          bold: true,
          alignment: 'center'
        }

      ],
    }
    const obj1 = { text: this.main.accInfo['address'], bold: true, alignment: 'center', style: 'header' };

    let headerInformation = this.dataToPrint[0]
    headerInformation['district'] = 'All Project'
    for (let i = 0; i < this.district_node.length; i++) {
      if (this.district_node[i]['node_cd'] === headerInformation['ld_cc_cd']) {
        headerInformation['district'] = this.district_node[i]['district']
      }
    }
    let tbl2 = {
      fontSize: 12,
      layout: "noBorders",
      table: {
        widths: [100, 300, 100, 300],
        body: [
          [
            { text: 'Date :', bold: true, margin: [5, 5, 5, 5] }, { text: new Date(headerInformation['acct_dt']).toLocaleDateString('en-GB'), margin: [5, 5, 5, 5] },
            { text: 'Voucher No :', bold: true, margin: [5, 5, 5, 5] }, { text: "JV/" + headerInformation['fin_year'] + "-" + (Number(headerInformation['fin_year']) + 1) + "/" + headerInformation['jrnl_id'], alignment: 'left', margin: [5, 5, 5, 5] }
          ],

          [
            { text: 'File name :', bold: true, margin: [5, 5, 5, 5] }, { text: headerInformation['ld_jrnl_ln_desc'], alignment: 'left', margin: [5, 5, 5, 5] },
            { text: 'Bill No. & Date :', bold: true, margin: [5, 5, 5, 5] }, { text: headerInformation['event_id'] + " & " + new Date(headerInformation['ld_unadj_acct_dt'].split('T')[0]).toLocaleDateString(), alignment: 'left', margin: [5, 5, 5, 5] }
          ]
          // { text: 'Division :', bold: true, margin: [5, 5, 5, 5] },
          // { text: headerInformation['ld_aff_cc_cd'], alignment: 'left', margin: [5, 5, 5, 5] },
          // { text: "HO", alignment: 'left', margin: [5, 5, 5, 5] },
          //   [
          //  ],
          // [{ text: 'Purchase Work Order Ref :', bold: true, colSpan: 2, margin: [5, 5, 5, 5] }, { text: "N/A", colSpan: 2, margin: [5, 5, 5, 5] }, {}, {}],
          // { text: 'Head Office / Project Office :', bold: true, margin: [5, 5, 5, 5] }, { text: "N/A", alignment: 'left', margin: [5, 5, 5, 5] },
        ],
      }
    };

    dd.content.push(obj1);
    dd.content.push({ text: " " });
    dd.content.push({ text: 'Head Office', alignment: 'center', bold: true, style: 'header', fontSize: 13 });
    dd.content.push({ text: " " });
    dd.content.push(header0);
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    dd.content.push(tbl2);
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    let tbl = {
      fontSize: 10,
      table: {
        widths: [50, 170, 100, 100, 100, 90, 90],
        body: [
          [
            { text: 'S.No', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Particulars', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'General Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Sub Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Budget Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Amount', alignment: 'center', bold: true, colSpan: 2 },
            { text: "" }
          ],
          [{ text: "" }, { text: "" }, { text: "" }, { text: "" }, { text: "" },
          { text: 'Debit Amount', bold: true, alignment: 'center' },
          { text: 'Credit Amount', bold: true, alignment: 'center' }]
        ],
      }
    };
    dd.content.push(tbl);
    let mapped_desc = ""
    for (let i = 0; i < this.dataToPrint.length; i++) {
      let arr = []

      if (this.dataToPrint[i]['chart_of_account'] === "CH11133") {//Sundry Creditor
        mapped_desc = " (" + this.dataToPrint[i]['ar_cntr_ip_name']
        if (this.dataToPrint[i]['ld_bugt_cd'] != "NONBUD" && this.dataToPrint[i]['db'] > 0) mapped_desc += this.budHierObj[this.dataToPrint[i]['bud_cd']] + " )"
        else mapped_desc + " )"
      }
      else if (this.dataToPrint[i]['chart_of_account'] === "CH1122031") {//Cash at bank
        mapped_desc = " (" + this.coa_mapped_bank[this.dataToPrint[i]['cp_bnk_acct_id']]
        if (this.dataToPrint[i]['ld_bugt_cd'] != "NONBUD" && this.dataToPrint[i]['db'] > 0) mapped_desc += this.budHierObj[this.dataToPrint[i]['bud_cd']] + " )"
        else mapped_desc + " )"
      }
      else {
        mapped_desc = ""
      }


      //Budget Description
      if (this.dataToPrint[i]['ld_bugt_cd'] != "NONBUD" && this.dataToPrint[i]['db'] > 0) {
        mapped_desc += " ( " + this.budHierObj[this.dataToPrint[i]['ld_bugt_cd']] + " )"
      }

      if (i <= this.dataToPrint.length - 2) {
        arr.push({ text: (i + 1), alignment: 'center' });
        arr.push({ text: this.chartOfAccObj[this.dataToPrint[i]['chart_of_account']] + mapped_desc, alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['chart_of_account'], alignment: 'left' });
        arr.push({ text: "" })
        arr.push({ text: this.dataToPrint[i]['ld_bugt_cd'] != "NONBUD" ? this.dataToPrint[i]['ld_bugt_cd'] : " ", alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['db'], alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['cr'], alignment: 'center' });

        // dd.content[dd.content.length - 1].table.body.push(arr);
      }

      //Showing Total Amount
      if (i == this.dataToPrint.length - 1) {
        // let arr = []
        arr.push({ text: "Total ", alignment: 'center', bold: true, colSpan: 5 });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: this.dataToPrint[i]['db'], alignment: 'center', bold: true });
        arr.push({ text: this.dataToPrint[i]['cr'], alignment: 'center', bold: true });
      }
      dd.content[dd.content.length - 1].table.body.push(arr);
    }

    dd.content.push({ text: " " })
    dd.content.push({ text: " " })

    const toWords = new ToWords();

    let words = toWords.convert(this.dataToPrint[this.dataToPrint.length - 1]['cr']);
    let total = {
      columns: [
        {
          width: '*',
          text: `Total :  ` + words + " Rupees Only.",
          bold: true,
        }
      ],
    }
    // let narration = {
    //   columns: [
    //     {
    //       width: "*",
    //       text: "NARRATION : Being amount credited to firm as per sanction enclosed.",
    //     }
    //   ]
    // }

    dd.content.push(total)
    dd.content.push({ text: " " })
    // dd.content.push(narration)
    dd.content.push({ text: "", margin: [0, 25, 0, 0] })


    // let obj = {}
    // this.statusArr.map((x:any) => {
    //   if (x['role_cd'] === "Sec." || x['role_cd'] === "Dir") { // Director   Secretary
    //     obj['DIR'] = x['user_name']
    //   }
    //   if (x['role_cd'] === "SA") { //Senior Accountant
    //     obj['SA'] = x['user_name']
    //   }
    //   if (x['role_cd'] === "FAO") { // Finance & Account Officer
    //     obj['FAO'] = x['user_name']
    //   }
    //   if (x['role_cd'] === "ACC") { // Accountant/ Cashier
    //     obj['ACC'] = x['user_name']
    //   }
    // })


    // let signature = {
    //   fontSize: 10,
    //   layout: "noBorders",
    //   table: {
    //     widths: [120, 120, 150, 120],
    //     body: [
    //       [{ text: '(JA/SA)', bold: true },//margin: [0, 5, 0, 5]
    //       { text: "(Accountant)", bold: true },
    //       { text: '(Finance & Account Officer)', bold: true },
    //       { text: "(Secretary/Director)", bold: true }],

    //       [{ text: " ", bold: true },//margin: [0, 5, 0, 5]
    //       { text: " ", bold: true },
    //       { text: " ", bold: true },
    //       { text: " ", bold: true }],

    //       [{ text: obj['SA'], bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //       { text: obj['ACC'], bold: true, alignment: "center", },
    //       { text: obj['FAO'], bold: true, alignment: "center", },
    //       { text: obj['DIR'], bold: true, alignment: "center", }],
    //     ],
    //   }
    // };

    // dd.content.push({ text: " " });
    // dd.content.push({ text: " " });
    // dd.content.push({ text: " " });
    // dd.content.push(signature)
    // this.spinner.hide()

    //   let obj:any = {}
    //   this.statusArr.map((x:any) => {
    //     if (x['role_cd'] === "Sec." || x['role_cd'] === "Dir") { // Director   Secretary
    //       obj['DIR'] = x['user_name']
    //       obj['DIR_status'] = x['status']
    //       obj['DIR_role_cd'] = x['role_cd']
    //     }
    //     if (x['role_cd'] === "SCL") { //Senior Clerk
    //       obj['SCL'] = x['user_name']
    //       obj['SCL_status'] = x['status']
    //       obj['SCL_role_cd'] = x['role_cd']
    //     }
    //     if (x['role_cd'] === "FAO") { // Finance & Account Officer
    //       obj['FAO'] = x['user_name']
    //       obj['FAO_status'] = x['status']
    //       obj['FAO_role_cd'] = x['role_cd']
    //     }
    //     if (x['role_cd'] === "SA") { // Senior Accountant/ Cashier
    //       obj['SA'] = x['user_name']
    //       obj['SA_status'] = x['status']
    //       obj['SA_role_cd'] = x['role_cd']
    //     }
    //   })

    //   if(this.statusArr.length>0){

    //   let signature = {
    //     fontSize: 10,
    //     layout: "noBorders",

    //     table: {
    //       widths: [120, 120, 150, 120],
    //       body: [
    //         [{ text:obj['SCL'].length>2?obj['SCL']:'', bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //         { text: obj['SA'].length>2?obj['SA']:'', bold: true, alignment: "center", },
    //         { text: obj['FAO'].length>2?obj['FAO']:'', bold: true, alignment: "center", },
    //         { text: obj['DIR'].length>2?obj['DIR'] + " (" + obj['DIR_role_cd'] + ")":'', bold: true, alignment: "center", }],

    //         [{ text: obj['SCL_status'].length>2?obj['SCL_status']:'', bold: true, alignment: "center", },
    //         { text: obj['SA_status'].length>2?obj['SA_status']:'', bold: true, alignment: "center", },
    //         { text: obj['FAO_status'].length>2?obj['FAO_status']:'', bold: true, alignment: "center", },
    //         { text: obj['DIR_status'].length>2?obj['DIR_status']:'', bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //         ],
    //         [
    //           { text: '(Senior Clerk)', bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //           { text: "(Senior Accountant)", bold: true, alignment: "center", },
    //           { text: '(Finance & Account Officer)', bold: true, alignment: "center", },
    //           { text: "(Secretary/Director)", bold: true, alignment: "center", }],

    //         [{ text: " ", bold: true },//margin: [0, 5, 0, 5]
    //         { text: " ", bold: true },
    //         { text: " ", bold: true },
    //         { text: " ", bold: true }],


    //       ],
    //     }
    //   };

    //   dd.content.push({ text: " " });
    //   dd.content.push({ text: " " });
    //   dd.content.push({ text: " " });
    //   dd.content.push(signature)
    // }

    if (this.signature_data.length > 0) {
      let signature = {
        fontSize: 10,
        layout: "noBorders",
        alignment: 'right',
        table: {
          body: [],
        },
      };
      dd.content.push(signature);
      let roleRow = [];
      let statusRow = [];
      let roleNameRow = [];
      for (let i = 0; i < this.signature_data.length; i++) {
        roleRow.push({ text: this.signature_data[i]['user_name'], bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });
        statusRow.push({ text: this.signature_data[i]['status'], bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });
        roleNameRow.push({ text: "(" + this.signature_data[i]['role_desc'] + ")", bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });


      }
      dd.content[dd.content.length - 1].table.body.push(roleRow);
      dd.content[dd.content.length - 1].table.body.push(statusRow);
      dd.content[dd.content.length - 1].table.body.push(roleNameRow);

      dd.content.push({ text: " " });
      dd.content.push({ text: " " });
      dd.content.push({ text: " " });
      dd.content.push(signature)

    }
    this.spinner.hide()
    // pdfMake.createPdf(dd).download("Manual Journal");
    pdfMake.createPdf(dd).open();
  }


  dataToPrint: any = []
  coa_mapped_bank: any = {}
  async _formatingDataForBpAndJv(element: any) {
    await this.getChartOfAccount();
    await this.getBudgetHier();
    await this.viewStatus({ ...element, module_cd: "ACCOUNT", is_account_module: 1 })

    this.spinner.show()
    this.dataToPrint = []
    let new_obj: any = {}
    new_obj['b_acct_id'] = this.b_acct_id
    new_obj['jrnl_id'] = element['jrnl_id']
    new_obj['ar_actvty_tcd'] = element.ar_actvty_tcd;
    new_obj['ar_actvty_lcl_num'] = element.ar_actvty_lcl_num;

    const resp = await this.jvService.get_Jrnl_Id_Full_Info(JSON.stringify(new_obj))
    if (resp['error'] == false) {
      const jrnl_data = resp['data'][0]
      if (jrnl_data.length == 0) {
        Swal.fire('Error', 'Something went wrong', 'error')
        return;
      }

      resp['data'][1].map((x: any) => {
        // this.coa_mapped_bank[x['chart_of_account']] = x['bank_code'] + " ( " + x['bank_acct_no'] + " )"
        this.coa_mapped_bank[x['relation']] = x['bank_code'] + " ( " + x['bank_acct_no'] + " )"
      })
      let txn_obj: any = new Object()


      jrnl_data.map((x: any) => {
        x['acct_dt'] = x['acct_dt'].split('T')[0]
        if (x['db_cd_ind'] === 'DB') {//jrnl_data[i]['ar_actvty_tcd'] === "BP" ? this.coa_mapped_bank[jrnl_data[i]['chart_of_account']] : jrnl_data[i]['chart_acct']
          x['db'] = -1 * x['txn_amt']
          x['cr'] = 0
          // x['mapped_with_coa'] = this.chartOfAccObj[x['chart_of_account']] +"("+ x['ar_actvty_tcd'] === "BP" ? this.coa_mapped_bank[x['chart_of_account']] : x['chart_of_account'] === "CH11133" ?   this.AllPartyObj[x['ar_cntr_ip_id']]:"" +")" //x['chart_of_account'] + "(" + this.chartOfAccObj[x['chart_of_account']] + ")"
        }
        else if (x['db_cd_ind'] === 'CR') {
          x['cr'] = x['txn_amt']
          x['db'] = 0
          // x['chart_of_account'] = x['chart_of_account'] + "(" + this.chartOfAccObj[x['chart_of_account']] + ")"
          // x['mapped_with_coa'] = this.chartOfAccObj[x['chart_of_account']] +"("+ x['ar_actvty_tcd'] === "BP" ? this.coa_mapped_bank[x['chart_of_account']] : x['chart_of_account'] === "CH11133" ?   this.AllPartyObj[x['ar_cntr_ip_id']]:"" +")" //x['chart_of_account'] + "(" + this.chartOfAccObj[x['chart_of_account']] + ")"
        }
      })
      let objToUniq: any = {}
      jrnl_data.map((x: any) => {
        if (objToUniq[x['chart_of_account']]) {
          objToUniq[x['chart_of_account']]['db'] += x['db']
          objToUniq[x['chart_of_account']]['cr'] += x['cr']
        } else {
          objToUniq[x['chart_of_account']] = x
        }

        // transaction details
        if (x['chart_of_account'] === "CH112213") { //Salary Payable
          if (!txn_obj[x['ar_cntr_ip_name']]) {
            txn_obj[x['ar_cntr_ip_name']] = JSON.parse(JSON.stringify(x))
          } else {
            txn_obj[x['ar_cntr_ip_name']]['db'] = x['db'];
            txn_obj[x['ar_cntr_ip_name']]['cr'] = x['cr'];
          }
        }

      })

      let dataToPrint = Object.values(objToUniq)
      let db2 = 0;
      let cr2 = 0;
      dataToPrint.map((x: any) => {
        if (x['db'] > x['cr']) {
          x['db'] = x['db'] - x['cr']
          x['cr'] = 0

          db2 += x['db'];

        } else {
          x['cr'] = x['cr'] - x['db']
          x['db'] = 0
          cr2 += x['cr']
        }
      })


      let DEBIT_FIRST_DATA = []
      dataToPrint.map((x: any) => {
        if (x['db'] > 0) {
          DEBIT_FIRST_DATA.push(x);
        }
      })
      dataToPrint.map((x: any) => {
        if (x['cr'] > 0) {
          DEBIT_FIRST_DATA.push(x);
        }
      })

      let no: any = {}
      no['db'] = db2
      no['cr'] = cr2
      no['chart_acct'] = ''
      no['ld_jrnl_ln_desc'] = 'Total Amount'
      DEBIT_FIRST_DATA.push(no)
      this.dataToPrint = DEBIT_FIRST_DATA;
      this.spinner.hide()
    } else {
      this.spinner.hide()
    }


  }


  signature_data: any = []
  async getworkflowlogforprint(element: any) {

    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj['current_doc_type'] = element['ar_actvty_tcd']
    obj['event_id'] = element['event_id']
    if (element['ar_actvty_tcd'] == 'VENDOR_BILL_OPERATION') {
      obj['module_cd'] = 'OPERATION'
      obj['prev_doc_type'] = 'VENDOR_BILL'
    }
    if (element['ar_actvty_tcd'] == 'SALARY_BILL') {
      obj['module_cd'] = 'HR'
      obj['prev_doc_type'] = 'SAL_BILL'
    }
    if (element['ar_actvty_tcd'] == 'DA_ARREAR_BILL') {
      obj['module_cd'] = 'HR'
      obj['prev_doc_type'] = 'DA_ARREAR'
    }
    if (element['ar_actvty_tcd'] == 'ARREAR_BILL') {
      obj['module_cd'] = 'HR'
      obj['prev_doc_type'] = 'AA_BILL'
    }
    if (element['ar_actvty_tcd'] == 'MANUAL_JRNL') {
      obj['module_cd'] = 'ACCOUNT'
      obj['current_doc_type'] = 'MANUAL_JOURNAL'
    }
    if (element['ar_actvty_tcd'] == 'Contra') {
      obj['module_cd'] = 'ACCOUNT'
      obj['current_doc_type'] = 'Contra'
    }
    if (element['ar_actvty_tcd'] == 'CB_BILL') {
      obj['module_cd'] = 'ACCOUNT'
      obj['current_doc_type'] = 'CB_BILL'
    }

    let resp = await this.jvService.getworkflowlogforprint(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.spinner.hide()

      this.signature_data = resp.data.flat()

    } else {
      this.spinner.hide()
    }


  }

  district_node: any = [{ node_cd: '35', district: 'Lucknow' }, { node_cd: '681', district: 'Chinhat' }]
  async printJournalVoucher(element: any) {


    await this._formatingDataForBpAndJv(element)
    await this.getworkflowlogforprint(element)
    this.spinner.show()

    let txt = this.main.accInfo['account_name'] + '(' + this.main.accInfo['account_short_name'] + ')';

    let dd: any = {

      pageSize: 'A4',
      header: function (currentPage: any, pageCount: any) {
        let obj = { text: txt, alignment: 'center', blod: true, style: 'header', margin: [72, 40] };
        + "     Page No. - " + pageCount
        return obj;
      },
      footer: {
        columns: [
          { text: new Date().toLocaleString(), alignment: 'right', margin: [0, 0, 40, 0] }
        ]
      },
      pageOrientation: 'portrait',

      pageMargins: [40, 60, 40, 60],
      content: [
      ]
    };
    let header0 = {
      columns: [
        {
          width: '*',
          text: 'JOURNAL VOUCHER',
          bold: true,
          alignment: 'center'
        }

      ],
    }

    const obj1: any = { text: this.main.accInfo['address'], bold: true, alignment: 'center', style: 'header' };


    let headerInformation = this.dataToPrint[0]
    headerInformation['district'] = 'All Project'
    headerInformation['ld_jrnl_ln_desc'] = headerInformation['ld_jrnl_ln_desc'].split('(')['0'] + " ( All Project )"
    for (let i = 0; i < this.district_node.length; i++) {
      if (this.district_node[i]['node_cd'] === headerInformation['ld_cc_cd']) {
        headerInformation['district'] = this.district_node[i]['district']
        headerInformation['ld_jrnl_ln_desc'] = this.district_node[i]['district']
      }
    }
    let tbl2 = {
      fontSize: 12,
      layout: "noBorders",
      table: {
        widths: ['*', '*', '*', '*'],
        body: [
          [{ text: 'Date :', bold: true, margin: [0, 5, 0, 5] }, { text: new Date(headerInformation['acct_dt']).toLocaleDateString('en-GB'), margin: [0, 5, 0, 5] },
          { text: 'Voucher No :', bold: true, margin: [0, 5, 0, 5] }, {
            text: "JV/" + headerInformation['fin_year'] + "-" + (Number(headerInformation['fin_year']) + 1) + "/" + headerInformation['jrnl_id'],
            alignment: 'left', margin: [0, 5, 0, 5]
          }],
          [{ text: 'District :', bold: true, margin: [0, 5, 0, 5] }, { text: headerInformation['district'], alignment: 'left', margin: [0, 5, 0, 5] },


          { text: 'File Name :', bold: true, margin: [0, 5, 0, 5] }, { text: headerInformation['ld_jrnl_ln_desc'], alignment: 'left', margin: [0, 5, 0, 5] }],
          [{ text: 'Bill No. & Date :', bold: true, margin: [0, 5, 0, 5] }, { text: headerInformation['ar_actvty_lcl_num'] + " & " + new Date(headerInformation['ev_cts'].split('T')[0]).toLocaleDateString(), alignment: 'left', margin: [0, 5, 0, 5] }, {}, {}]
          // [{ text: 'Purchase Work Order Ref :', bold: true, colSpan: 2, margin: [0, 5, 0, 5] }, { text: " ", colSpan: 2, margin: [0, 5, 0, 5] }, {}, {}],
          // { text: 'Head Office / Project Office :', bold: true, margin: [0, 5, 0, 5] }, { text: " " + headerInformation['ld_aff_cc_cd'], alignment: 'left', margin: [0, 5, 0, 5] },
        ],
      }
    };

    dd.content.push(obj1);
    dd.content.push({ text: " " });
    dd.content.push({ text: 'Head Office', alignment: 'center', bold: true, style: 'header', fontSize: 13 });
    dd.content.push({ text: " " });
    dd.content.push(header0);
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    dd.content.push(tbl2);
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    let tbl = {
      fontSize: 10,
      table: {
        widths: [30, 110, 65, 60, 65, 55, 55],
        body: [
          [
            { text: 'S.No', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Particulars', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'General Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Sub Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Budget Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Amount', alignment: 'center', bold: true, colSpan: 2 },
            { text: "" }
          ],
          [{ text: "" }, { text: "" }, { text: "" }, { text: "" }, { text: "" },
          { text: 'Debit Amount', bold: true, alignment: 'center' },
          { text: 'Credit Amount', bold: true, alignment: 'center' }]
        ],
      }
    };
    dd.content.push(tbl);
    let vendor_name: string = ""
    for (let i = 0; i < this.dataToPrint.length; i++) {
      let arr = []
      if (this.dataToPrint[i]['chart_of_account'] === "CH11133") {
        vendor_name = "(" + this.dataToPrint[i]['ar_cntr_ip_name'] + ")"

      } else if (this.dataToPrint[i]['chart_of_account'] === "CH1122031") {//cash   at bank
        vendor_name = "(" + this.coa_mapped_bank[this.dataToPrint[i]['cp_bnk_acct_id']] + ")"
      } else {
        vendor_name = " "

      }
      if (i === 0) {
        arr.push({ text: (i + 1), alignment: 'center' });
        arr.push({ text: this.chartOfAccObj[this.dataToPrint[i]['chart_of_account']] + vendor_name, alignment: 'left' });
        arr.push({ text: this.dataToPrint[i]['chart_of_account'], alignment: 'left' });
        arr.push({ text: "" })
        arr.push({ text: this.dataToPrint[i]['ld_bugt_cd'], alignment: 'left' });
        arr.push({ text: this.dataToPrint[i]['db'], alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['cr'], alignment: 'center' });
      }
      if (i > 0 && i != this.dataToPrint.length - 1) {
        arr.push({ text: (i + 1), alignment: 'center' });
        arr.push({ text: this.chartOfAccObj[this.dataToPrint[i]['chart_of_account']] + vendor_name, alignment: 'left' });
        arr.push({ text: this.dataToPrint[i]['chart_of_account'], alignment: 'left' });
        arr.push({ text: "" })
        arr.push({ text: "", alignment: 'left' });
        arr.push({ text: this.dataToPrint[i]['db'], alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['cr'], alignment: 'center' });
      }

      //Showing Total Amount
      if (i == this.dataToPrint.length - 1) {
        arr.push({ text: "Total ", alignment: 'center', bold: true, colSpan: 5 });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: this.dataToPrint[i]['db'], alignment: 'center', bold: true });
        arr.push({ text: this.dataToPrint[i]['cr'], alignment: 'center', bold: true });
      }
      dd.content[dd.content.length - 1].table.body.push(arr);
    }

    dd.content.push({ text: " " })
    dd.content.push({ text: " " })

    const toWords = new ToWords();

    let words = toWords.convert(this.dataToPrint[this.dataToPrint.length - 1]['cr']);
    let total = {
      columns: [
        {
          width: '*',
          text: `Total :  ` + words + " Rupees Only.",
          bold: true,
        }
      ],
    }
    let narration = {
      columns: [
        {
          width: "*",
          text: "NARRATION : Being amount credited to firm as per sanction enclosed.",
        }
      ]
    }

    dd.content.push(total)
    dd.content.push({ text: " " })
    dd.content.push(narration)
    // dd.content.push({ text: "", margin: [0, 15, 0, 0] })
    // dd.content.push({ text: "chq......" })
    dd.content.push({ text: "", margin: [0, 25, 0, 0] })


    //     let obj:any = {}
    //     this.statusArr.map((x:any) => {
    //       if (x['role_cd'] === "Sec." || x['role_cd'] === "Dir") { // Director   Secretary
    //         obj['DIR'] = x['user_name']
    //         obj['DIR_status'] = x['status']
    //         obj['DIR_role_cd'] = x['role_cd']
    //       }
    //       if (x['role_cd'] === "SCL") { //Senior Clerk
    //         obj['SCL'] = x['user_name']
    //         obj['SCL_status'] = x['status']
    //         obj['SCL_role_cd'] = x['role_cd']
    //       }
    //       if (x['role_cd'] === "FAO") { // Finance & Account Officer
    //         obj['FAO'] = x['user_name']
    //         obj['FAO_status'] = x['status']
    //         obj['FAO_role_cd'] = x['role_cd']
    //       }
    //       if (x['role_cd'] === "SA") { // Senior Accountant/ Cashier
    //         obj['SA'] = x['user_name']
    //         obj['SA_status'] = x['status']
    //         obj['SA_role_cd'] = x['role_cd']
    //       }
    //     })

    // if(this.statusArr.length>0){
    //     let signature = {
    //       fontSize: 10,
    //       layout: "noBorders",

    //       table: {
    //         widths: [120, 120, 150, 120],
    //         body: [
    //           [{ text: obj['SCL'], bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //           { text: obj['SA'], bold: true, alignment: "center", },
    //           { text: obj['FAO'], bold: true, alignment: "center", },
    //           { text: obj['DIR'] + " (" + obj['DIR_role_cd'] + ")", bold: true, alignment: "center", }],

    //           [{ text: obj['SCL_status'], bold: true, alignment: "center", },
    //           { text: obj['SA_status'], bold: true, alignment: "center", },
    //           { text: obj['FAO_status'], bold: true, alignment: "center", },
    //           { text: obj['DIR_status'], bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //           ],
    //           [
    //             { text: '(Senior Clerk)', bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //             { text: "(Senior Accountant)", bold: true, alignment: "center", },
    //             { text: '(Finance & Account Officer)', bold: true, alignment: "center", },
    //             { text: "(Secretary/Director)", bold: true, alignment: "center", }],

    //           [{ text: " ", bold: true },//margin: [0, 5, 0, 5]
    //           { text: " ", bold: true },
    //           { text: " ", bold: true },
    //           { text: " ", bold: true }],


    //         ],
    //       }
    //     };

    //     dd.content.push({ text: " " });
    //     dd.content.push({ text: " " });
    //     dd.content.push({ text: " " });
    //     dd.content.push(signature)
    //   }

    if (this.signature_data.length > 0) {
      let signature = {
        fontSize: 10,
        layout: "noBorders",
        alignment: 'right',
        table: {
          body: [],
        },
      };
      dd.content.push(signature);
      let roleRow = [];
      let statusRow = [];
      let roleNameRow = [];
      for (let i = 0; i < this.signature_data.length; i++) {
        roleRow.push({ text: this.signature_data[i]['user_name'], bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });
        statusRow.push({ text: this.signature_data[i]['status'], bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });
        roleNameRow.push({ text: "(" + this.signature_data[i]['role_desc'] + ")", bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });


      }
      dd.content[dd.content.length - 1].table.body.push(roleRow);
      dd.content[dd.content.length - 1].table.body.push(statusRow);
      dd.content[dd.content.length - 1].table.body.push(roleNameRow);


      dd.content.push({ text: " " });
      dd.content.push({ text: " " });
      dd.content.push({ text: " " });
      dd.content.push(signature)
    }

    this.spinner.hide()
    pdfMake.createPdf(dd).download("Journal Voucher");
  }

  async printBankVoucher(element: any) {
    await this._formatingDataForBpAndJv(element)
    await this.getworkflowlogforprint(element)
    this.spinner.show()
    let txt = this.main.accInfo['account_name'] + '(' + this.main.accInfo['account_short_name'] + ')';
    let dd: any = {
      pageSize: 'A4',
      header: function (currentPage: any, pageCount: any) {
        let obj = { text: txt, alignment: 'center', blod: true, style: 'header', margin: [72, 40] };
        + "     Page No. - " + pageCount
        return obj;
      },
      footer: {
        columns: [
          { text: new Date().toLocaleString(), alignment: 'right', margin: [0, 0, 40, 0] }
        ]
      },
      pageOrientation: 'portrait',

      pageMargins: [40, 60, 40, 60],
      content: [
      ]
    };
    let header0 = {
      columns: [
        {
          width: '*',
          text: 'BANK VOUCHER',
          bold: true,
          alignment: 'center'
        }

      ],
    }
    const obj1 = { text: this.main.accInfo['address'], bold: true, alignment: 'center', style: 'header' };

    let headerInformation = this.dataToPrint[0]
    headerInformation['district'] = 'All Project'
    for (let i = 0; i < this.district_node.length; i++) {
      if (this.district_node[i]['node_cd'] === headerInformation['ld_cc_cd']) {
        headerInformation['district'] = this.district_node[i]['district']
      }
    }
    let tbl2 = {
      fontSize: 12,
      layout: "noBorders",
      table: {
        widths: ['*', '*', '*', '*'],
        body: [
          [{ text: 'Date :', bold: true, margin: [0, 5, 0, 5] }, { text: new Date(headerInformation['acct_dt']).toLocaleDateString('en-GB'), margin: [0, 5, 0, 5] },
          { text: 'Voucher No :', bold: true, margin: [0, 5, 0, 5] }, {
            text: "JV/" + headerInformation['fin_year'] + "-" + (Number(headerInformation['fin_year']) + 1) + "/" + headerInformation['jrnl_id'],
            alignment: 'left', margin: [0, 5, 0, 5]
          }],
          [{ text: 'District :', bold: true, margin: [0, 5, 0, 5] }, { text: headerInformation['district'], alignment: 'left', margin: [0, 5, 0, 5] },


          { text: 'File Name :', bold: true, margin: [0, 5, 0, 5] }, { text: headerInformation['ld_jrnl_ln_desc'], alignment: 'left', margin: [0, 5, 0, 5] }],
          [{ text: 'Bill No. & Date :', bold: true, margin: [0, 5, 0, 5] }, { text: headerInformation['ar_actvty_lcl_num'] + " & " + new Date(headerInformation['ev_cts'].split('T')[0]).toLocaleDateString(), alignment: 'left', margin: [0, 5, 0, 5] }, {}, {}],
          // [{ text: 'Purchase Work Order Ref :', bold: true, colSpan: 2, margin: [0, 5, 0, 5] }, { text: " ", colSpan: 2, margin: [0, 5, 0, 5] }, {}, {}],
          // { text: 'Head Office / Project Office :', bold: true, margin: [0, 5, 0, 5] }, { text: " " + headerInformation['ld_aff_cc_cd'], alignment: 'left', margin: [0, 5, 0, 5] },
        ],
      }
    };

    dd.content.push(obj1);
    dd.content.push({ text: " " });
    dd.content.push({ text: 'Head Office', alignment: 'center', bold: true, style: 'header', fontSize: 13 });
    dd.content.push({ text: " " });
    dd.content.push(header0);
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    dd.content.push(tbl2);
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    let tbl = {
      fontSize: 10,
      table: {
        widths: [120, 55, 40, 50, 75, 50, 50],
        body: [
          [
            { text: 'Particulars', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'General Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Sub Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Budget Ledger Code', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Budget Description', alignment: 'center', bold: true, rowSpan: 2 },
            { text: 'Amount', alignment: 'center', bold: true, colSpan: 2 },
            { text: "" }
          ],
          [{ text: "" }, { text: "" }, { text: "" }, { text: "" }, { text: "" },
          { text: 'Debit Amount', bold: true, alignment: 'center' },
          { text: 'Credit Amount', bold: true, alignment: 'center' }]
        ],
      }
    };
    dd.content.push(tbl);
    let mapped_with_coa = ""
    for (let i = 0; i < this.dataToPrint.length; i++) {
      mapped_with_coa = this.dataToPrint[i]['chart_of_account'] === "CH1122031" ? "(" + this.coa_mapped_bank[this.dataToPrint[i]['cp_bnk_acct_id']] + ")" : this.dataToPrint[i]['chart_of_account'] === "CH11133" ? " (" + this.dataToPrint[i]['ar_cntr_ip_name'] + ") " : ""
      let arr = []
      if (i === 0) {
        arr.push({ text: this.chartOfAccObj[this.dataToPrint[i]['chart_of_account']] + mapped_with_coa, alignment: 'left' });
        arr.push({ text: this.dataToPrint[i]['chart_of_account'], alignment: 'left' });
        arr.push({ text: "" })
        arr.push({ text: this.dataToPrint[i]['ld_bugt_cd'] == "NONBUD" ? " " : this.dataToPrint[i]['ld_bugt_cd'], alignment: 'left' });
        arr.push({ text: this.dataToPrint[i]['ld_bugt_cd'] == "NONBUD" ? " " : this.budHierObj[this.dataToPrint[i]['ld_bugt_cd']], alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['db'], alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['cr'], alignment: 'center' });
      }
      if (i > 0 && i != this.dataToPrint.length - 1) {
        arr.push({ text: this.chartOfAccObj[this.dataToPrint[i]['chart_of_account']] + mapped_with_coa, alignment: 'left' });
        arr.push({ text: this.dataToPrint[i]['chart_of_account'], alignment: 'left' });
        arr.push({ text: "" })
        arr.push({ text: "", alignment: 'left' });//this.dataToPrint[i]['ld_bugt_cd']
        arr.push({ text: this.dataToPrint[i]['ld_bugt_cd'] == "NONBUD" ? " " : this.budHierObj[this.dataToPrint[i]['ld_bugt_cd']], alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['db'], alignment: 'center' });
        arr.push({ text: this.dataToPrint[i]['cr'], alignment: 'center' });
      }

      //Showing Total Amount
      if (i == this.dataToPrint.length - 1) {
        arr.push({ text: "Total ", alignment: 'center', bold: true, colSpan: 5 });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: "" });
        arr.push({ text: this.dataToPrint[i]['db'], alignment: 'center', bold: true });
        arr.push({ text: this.dataToPrint[i]['cr'], alignment: 'center', bold: true });
      }
      dd.content[dd.content.length - 1].table.body.push(arr);
    }

    dd.content.push({ text: " " })
    dd.content.push({ text: " " })


    const toWords = new ToWords();
    let words = toWords.convert(this.dataToPrint[this.dataToPrint.length - 1]['cr']);
    let total = {
      columns: [
        {
          width: '*',
          text: `Total :  ` + words + " Rupees Only.",
          bold: true,
        }

      ],
    }

    let narration = {
      columns: [
        {
          width: "*",
          text: "NARRATION : Being amount credited to firm as per sanction enclosed.",
        }
      ]
    }

    dd.content.push(total)
    dd.content.push({ text: " " })
    dd.content.push(narration)
    // dd.content.push({ text: "", margin: [0, 15, 0, 0] })
    // dd.content.push({ text: "chq......" })
    dd.content.push({ text: "", margin: [0, 25, 0, 0] })

    // let obj = {}
    // this.statusArr.map((x:any) => {
    //   if (x['role_cd'] === "Sec." || x['role_cd'] === "Dir") { // Director   Secretary
    //     obj['DIR'] = x['user_name']
    //   }
    //   if (x['role_cd'] === "SA") { //Senior Accountant
    //     obj['SA'] = x['user_name']
    //   }
    //   if (x['role_cd'] === "FAO") { // Finance & Account Officer
    //     obj['FAO'] = x['user_name']
    //   }
    //   if (x['role_cd'] === "ACC") { // Accountant/ Cashier
    //     obj['ACC'] = x['user_name']
    //   }
    // })






    // let signature = {
    //   fontSize: 10,
    //   layout: "noBorders",
    //   table: {
    //     widths: [120, 120, 150, 120],
    //     body: [
    //       [{ text: '(JA/SA)', bold: true },//margin: [0, 5, 0, 5]
    //       { text: "(Accountant)", bold: true },
    //       { text: '(Finance & Account Officer)', bold: true },
    //       { text: "(Secretary/Director)", bold: true }],

    //       [{ text: " ", bold: true },//margin: [0, 5, 0, 5]
    //       { text: " ", bold: true },
    //       { text: " ", bold: true },
    //       { text: " ", bold: true }],

    //       [{ text: obj['SA'], bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //       { text: obj['ACC'], bold: true, alignment: "center", },
    //       { text: obj['FAO'], bold: true, alignment: "center", },
    //       { text: obj['DIR'], bold: true, alignment: "center", }],
    //     ],
    //   }
    // };

    // dd.content.push({ text: " " });
    // dd.content.push({ text: " " });
    // dd.content.push({ text: " " });
    // dd.content.push(signature)
    // this.spinner.hide()

    // let obj = {DIR:'',DIR_status:'',DIR_role_cd:'',SCL:'',SCL_status:'',SCL_role_cd:'',FAO:'',FAO_status:'',FAO_role_cd:'',SA:'',SA_status:'',SA_role_cd:''}
    // this.statusArr.map(x => {
    //   if (x['role_cd'] === "Sec." || x['role_cd'] === "Dir") { // Director   Secretary
    //     obj['DIR'] = x['user_name']
    //     obj['DIR_status'] = x['status']
    //     obj['DIR_role_cd'] = x['role_cd']
    //   }
    //   if (x['role_cd'] === "SCL") { //Senior Clerk
    //     obj['SCL'] = x['user_name']
    //     obj['SCL_status'] = x['status']
    //     obj['SCL_role_cd'] = x['role_cd']
    //   }
    //   if (x['role_cd'] === "FAO") { // Finance & Account Officer
    //     obj['FAO'] = x['user_name']
    //     obj['FAO_status'] = x['status']
    //     obj['FAO_role_cd'] = x['role_cd']
    //   }
    //   if (x['role_cd'] === "SA") { // Senior Accountant/ Cashier
    //     obj['SA'] = x['user_name']
    //     obj['SA_status'] = x['status']
    //     obj['SA_role_cd'] = x['role_cd']
    //   }
    // })


    // let signature = {
    //   fontSize: 10,
    //   layout: "noBorders",
    //   table: {
    //     widths: [120, 120, 150, 120],
    //     body: [
    //       [{ text: obj['SCL'].length>2?obj['SCL']:'', bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //       { text: obj['SA'].length>2?obj['SA']:'', bold: true, alignment: "center", },
    //       { text: obj['FAO'].length>2? obj['FAO']:'', bold: true, alignment: "center", },
    //       { text:  obj['DIR'].length>2? obj['DIR'] + " (" + obj['DIR_role_cd'] + ")":'', bold: true, alignment: "center", }],

    //       [{ text: obj['SCL_status'], bold: true, alignment: "center", },
    //       { text: obj['SA_status'], bold: true, alignment: "center", },
    //       { text: obj['FAO_status'], bold: true, alignment: "center", },
    //       { text: obj['DIR_status'], bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //       ],
    //       [
    //         { text: '(Senior Clerk)', bold: true, alignment: "center", },//margin: [0, 5, 0, 5]
    //         { text: "(Senior Accountant)", bold: true, alignment: "center", },
    //         { text: '(Finance & Account Officer)', bold: true, alignment: "center", },
    //         { text: "(Secretary/Director)", bold: true, alignment: "center", }],

    //       [{ text: " ", bold: true },//margin: [0, 5, 0, 5]
    //       { text: " ", bold: true },
    //       { text: " ", bold: true },
    //       { text: " ", bold: true }],



    //     ],
    //   }
    // };
    if (this.signature_data.length > 0) {
      let signature = {
        fontSize: 10,
        layout: "noBorders",
        alignment: 'right',
        table: {
          body: [],
        },
      };
      dd.content.push(signature);
      let roleRow = [];
      let statusRow = [];
      let roleNameRow = [];
      for (let i = 0; i < this.signature_data.length; i++) {
        roleRow.push({ text: this.signature_data[i]['user_name'], bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });
        statusRow.push({ text: this.signature_data[i]['status'], bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });
        roleNameRow.push({ text: "(" + this.signature_data[i]['role_desc'] + ")", bold: true, alignment: 'center', margin: [10, 0, 10, 0,] });


      }
      dd.content[dd.content.length - 1].table.body.push(roleRow);
      dd.content[dd.content.length - 1].table.body.push(statusRow);
      dd.content[dd.content.length - 1].table.body.push(roleNameRow);

      dd.content.push({ text: " " });
      dd.content.push({ text: " " });
      dd.content.push({ text: " " });
      dd.content.push(signature)
    }

    this.spinner.hide()
    pdfMake.createPdf(dd).download("Bank Voucher");
  }


  async printUnpostedManualJournal(element: any) {
    await this.getChartOfAccount();
    await this.getBudgetHier();
    await this.getBankMappedCOA()
    await this.viewStatus({ ...element, module_cd: "ACCOUNT", is_account_module: 1 })

    this.spinner.show()
    this.dataToPrint = []
    let new_obj: any = {}
    new_obj['b_acct_id'] = this.b_acct_id
    new_obj['id'] = element['id']

    const resp = await this.ledgerService.getManulaJournalById(JSON.stringify(new_obj));


    if (resp['error'] == false) {
      const data = resp['data']
      const jrnl_data = JSON.parse(data[0]['data_lines'])

      console.log(jrnl_data);


      let txn_obj: any = {}

      jrnl_data.map((x: any) => {
        x['data']['acct_dt'] = x['data']['acct_dt']
        x['data']['ld_aff_cc_cd'] = x['data']['proj_cd']
        x['data']['event_id'] = data[0]['id']
        x['data']['ld_unadj_acct_dt'] = x['data']['acct_dt'] + "T" + "00:00:0000"
        x['data']['ld_bugt_cd'] = x['data']['bud_cd']
        if (x['data']['db_cd_ind'] === 'DB') {
          x['data']['db'] = x['data']['txn_amt']
          x['data']['cr'] = 0
        }
        else if (x['data']['db_cd_ind'] === 'CR') {
          x['data']['cr'] = x['data']['txn_amt']
          x['data']['db'] = 0
        }
      })

      let objToUniq: any = {}
      jrnl_data.map((x: any) => {
        if (objToUniq[x['data']['chart_of_account']]) {
          objToUniq[x['data']['chart_of_account']]['db'] += x['data']['db']
          objToUniq[x['data']['chart_of_account']]['cr'] += x['data']['cr']
        } else {
          objToUniq[x['data']['chart_of_account']] = x['data']
        }

        // transaction details
        if (x['data']['chart_of_account'] === "CH112213") { //Salary Payable
          if (!txn_obj[x['data']['ar_cntr_ip_name']]) {
            txn_obj[x['data']['ar_cntr_ip_name']] = x['data']
          } else {
            txn_obj[x['data']['ar_cntr_ip_name']]['db'] = x['data']['db'];
            txn_obj[x['data']['ar_cntr_ip_name']]['cr'] = x['data']['cr'];
          }
        }

      })

      let dataToPrint = Object.values(objToUniq)
      let db2 = 0;
      let cr2 = 0;
      dataToPrint.map((x: any) => {
        if (x['db'] > x['cr']) {
          x['db'] = x['db'] - x['cr']
          x['cr'] = 0

          db2 += x['db'];

        } else {
          x['cr'] = x['cr'] - x['db']
          x['db'] = 0
          cr2 += x['cr']
        }
      })


      let DEBIT_FIRST_DATA = []
      dataToPrint.map((x: any) => {
        if (x['db'] > 0) {
          DEBIT_FIRST_DATA.push(x);
        }
      })
      dataToPrint.map((x: any) => {
        if (x['cr'] > 0) {
          DEBIT_FIRST_DATA.push(x);
        }
      })

      let no: any = {}
      no['db'] = db2
      no['cr'] = cr2
      no['chart_acct'] = ''
      no['ld_jrnl_ln_desc'] = 'Total Amount'
      DEBIT_FIRST_DATA.push(no)
      this.dataToPrint = DEBIT_FIRST_DATA;
      this.printManualJournal({})

      this.spinner.hide()
    } else {
      this.spinner.hide()
    }

  }


  async viewJCR_Invoice(element: any, doc_type: any) {
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj['bill_id'] = element['doc_local_no']
    obj['is_account_module'] = element.is_account_module
    obj['view_doc_type'] = doc_type
    this.spinner.show()
    let res: any = await this.ledgerService.getbill_document(obj)
    try {
      if (res['type'] === "text/xml") {
        this.spinner.hide();
        Swal.fire('INFO', 'Document Not Uploaded', 'info')
        return;
      } else if (res) {
        let file = new Blob([res], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    } catch (error) {
      this.spinner.hide();
      Swal.fire('Error', `Can't fetch at the moment. Please try again later`, 'error')
    }

  }


  previous_log_status: any = []

  async getPreviousWorkflowLog(element: any) {
    let obj: any = {}
    obj['is_account_module'] = 0;
    obj['event_id'] = element.doc_local_no
    obj['ar_actvty_tcd'] = element.doc_type
    obj['module_cd'] = element.module_cd;
    obj['ld_prj_cd'] = element.node_cd
    this.previous_log_status = []
    this.previous_log_status = await this.viewStatus(obj)

    this.previous_log_status.map((x: any) => {
      if (x && 'remark' in x) {
        try {
          const parsedRemark = JSON.parse(x['remark']);
          if (typeof parsedRemark === 'object' && 'body' in parsedRemark) {
            x['remark'] = parsedRemark['body'];
          }
        } catch (e) {
          console.log('error')

        }
      }
    })
    // this.previous_log_status.map((x:any) => {
    //   if(JSON.parse(x['remark'])['body']){
    //     x['remark'] = JSON.parse(x['remark'])['body']

    //   }
    // })
  }
  // notesheet_data = {}
  // async getNotesheetData(data: any) {
  //   // this.notesheet_data = {}
  //   var obj = Object()
  //   obj['b_acct_id'] = this.erpUser.b_acct_id
  //   obj['bill_id'] = data.doc_local_no
  //   obj['is_account_module'] = data['module_cd'] === "ACCOUNT" ? 1 : 0;
  //   var resp = await this.vbillservice.getNotesheet(JSON.stringify(obj))
  //   if (resp['error'] == false) {
  //     // this.notesheet_data = resp['data'][0]['notesheet_desc'];
  //     // this.notesheet_data = JSON.parse(resp['data'][0]['notesheet_desc'])['body'];
  //     // if (resp['data'][0]['language'] === 'Hindi') {
  //     //   this.hindi_text_flag = true
  //     // } else {
  //     //   this.hindi_text_flag = false
  //     // }


  //     return { data: resp['data'][0]['notesheet_desc'], error: false, hindi_text_flag: resp['data'][0]['language'] === 'Hindi' ? true : false }

  //   } else {
  //     Swal.fire("Error", resp['data'], 'error');
  //     return { data: resp['data'], error: true }
  //   }
  // }
  fundNotesheet: any = {}
  async getFundTransferNotesheet(data: any) {

    var obj = Object()
    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['bud_trans_id'] = data.doc_local_no
    var resp = await this.jvService.getFundTransferNotesheet(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.fundNotesheet = JSON.parse(resp['data'][0]['desc'])
      return { data: this.fundNotesheet['body'], error: false, hindi_text_flag: this.fundNotesheet['is_hindi_font'] }

    } else {
      Swal.fire("Error", resp['data'], 'error');
      return { data: resp['data'], error: true }
    }
  }




  async getNotesheetOfPoReimbursement(data: any) {
    // this.notesheet_data = {}
    var obj = Object()
    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['rem_id'] = data.doc_local_no;
    obj['is_po_screen'] = data.is_po_screen
    var resp = await this.reimbursementService.getNotesheet(JSON.stringify(obj))
    if (resp['error'] == false) {
      return { data: JSON.parse(resp['data'][0]['desc']).body, error: false, hindi_text_flag: resp['data'][0]['language'] === 'Hindi' ? true : false }

    } else {
      Swal.fire("Error", resp['data'], 'error');
      return { data: resp['data'], error: true }
    }
  }


  async printMedicalDoc(data: any) {
    let obj = Object()
    obj['bill_id'] = data.bill_id;
    obj['is_account_module'] = data.is_account_module
    obj['b_acct_id'] = this.erpUser.b_acct_id;
    let resp: any = await this.geMedicalDocName(JSON.stringify(obj))
    if (resp.error == false) {
      for (let i = 0; i < resp.data.length; i++) {
        const blobRequest: any = await this.getAllMedicalDocument({ ...resp.data[i], b_acct_id: this.b_acct_id })
        if (blobRequest.type != "application/pdf") {
          Swal.fire('INFO', 'Document Not Uploaded', 'info')
          this.spinner.hide()
          return;
        } else {
          let file = new Blob([blobRequest], { type: "application/pdf" });
          let fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.spinner.hide();
        }
      }

    } else {
      Swal.fire('ERROR', 'Error While Getting Doument', 'error')
      this.spinner.hide()
    }
  }

  async getWorkDetailsByID(obj: any) {

    let workDetailsObj: any = {}
    let resp: any = await this.workService.getWorkDetailsByID(obj)
    if (resp.error == false) {
       workDetailsObj['data'] = resp.data[0];
       workDetailsObj['data']['additional_doc'] = JSON.parse(resp['data'][0]['additional_doc'])
       workDetailsObj['error'] = false;
      return workDetailsObj
    } else {
      console.log('Error While getting work info');
      this.spinner.hide()
      workDetailsObj['data'] = "Error While getting work info";
      workDetailsObj['error'] = true;
      return workDetailsObj;
    }


  }




  async getAllMedicalDocument(obj: any) {
    const resp = await this.http.post(this.httpUrl + '/accounts/eventgroup/getbill_medDocument', obj, { responseType: 'blob' }).toPromise().then(res => {
      try {
        return res;
      } catch (error) {
        return
      }
    });
    return resp;
  }



  async geMedicalDocName(obj: any) {
    const resp = await this.http.get(this.httpUrl + '/accounts/eventgroup/geMedicalDocName' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


}
